import { useOnboarding } from '../../context/OnboardingContext';
import { applyStyles } from '../../utils/styleUtils';

const IconTextElement = ({ element }) => {
  const { replaceTemplates } = useOnboarding();
  const style = applyStyles(element);

  return (
    <div className="element-icon-text" style={style}>
      {element.iconUrl && (
        <img 
          src={element.iconUrl} 
          alt="" 
          className="icon-text-image"
          style={{
            width: element.iconWidth || '20px',
            height: element.iconHeight || '20px',
          }}
        />
      )}
      <span className="icon-text-content">
        {replaceTemplates(element.text)}
      </span>
    </div>
  );
};

export default IconTextElement;
